import React from 'react'
import { ArrowUpRight, BadgeCheck, CheckCircle2, Globe, Layers, ShieldCheck, TrendingUp, Users, Zap } from "lucide-react";
function WhyChooseUs() {
      const features = [
          {
          icon: <ShieldCheck className="w-6 h-6 text-primary" />,
          title: "Trusted & Verified",
          desc: "We are a GST verified company delivering reliable and professional digital solutions.",
        },
        {
          icon: <Zap className="w-6 h-6 text-primary" />,
          title: "High Performance",
          desc: "Fast, optimized and scalable websites built for real business growth.",
        },
        {
          icon: <Globe className="w-6 h-6 text-primary" />,
          title: "Global Reach",
          desc: "We serve clients worldwide with modern digital systems and solutions.",
        },
        {
          icon: <Layers className="w-6 h-6 text-primary" />,
          title: "Modern UI/UX",
          desc: "Clean, modern and conversion-focused designs for better user experience.",
        },
        {
          icon: <TrendingUp className="w-6 h-6 text-primary" />,
          title: "Business Growth",
          desc: "We focus on results, leads, conversions and real business impact.",
        },
        {
          icon: <Users className="w-6 h-6 text-primary" />,
          title: "Expert Team",
          desc: "Skilled developers, designers and marketers working together.",
        },
        {
      icon: <BadgeCheck className="w-6 h-6 text-primary" />,
      title: "Guaranteed Results",
      desc: "We focus on real business results, not just design.",
    },
    {
      icon: <Zap className="w-6 h-6 text-primary" />,
      title: "Fastest Delivery",
      desc: "We deliver projects in minimum time without compromising quality.",
    },
      ];
  return (
     <section className="relative py-16 px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505]">

      {/* BACKGROUND */}
      <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary/10 blur-[140px] rounded-full" />
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-orange-300/10 blur-[140px] rounded-full" />

      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:70px_70px]" />

      <div className="relative z-10 max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 dark:text-white">
            Why Choose{" "}
            <span className="bg-gradient-to-r from-primary via-orange-400 to-yellow-400 bg-clip-text text-transparent">
              Us
            </span>
          </h2>

          <p className="myparagraph  text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            We combine creativity, technology and strategy to deliver powerful digital solutions.
          </p>
        </div>

        {/* GRID */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">

          {features.map((item, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl border border-black/5 dark:border-white/10 bg-white/70 dark:bg-white/5 backdrop-blur-xl hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(254,120,83,0.15)] transition-all duration-300"
            >

              {/* ICON */}
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary/10 mb-4 group-hover:scale-110 transition">
                {item.icon}
              </div>

              {/* TITLE */}
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">
                {item.title}
              </h3>

              {/* DESCRIPTION */}
              <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                {item.desc}
              </p>

            </div>
          ))}

        </div>

      </div>
    </section>
  )
}

export default WhyChooseUs
